import { Component, OnInit } from '@angular/core';
import { LearningResourceService } from '../../../core/services/learning-resource.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resource-article',
  templateUrl: './resource-article.component.html',
  styleUrls: ['./resource-article.component.scss'],
})
export class ResourceArticleComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Learning Resource-Articles',
    },
  ];
  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 4;
  searchValue = '';
  exceededLimit = false;

  constructor(
    private resourceService: LearningResourceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadArticles();
  }

  loadArticles(): void {
    this.resourceService
      .getArticles(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs; 
        this.totalDocs = response.totalDocs;
      });
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.loadArticles();
  }

  getArticlesBySearch(): void {
    this.resourceService
      .getArticlesBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  onCurrentPageDataChange(page: any): void {
    this.currentPage = page;
    this.loadArticles();
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  navToSingle(data: any): void {
    this.router.navigate([`/admin/single-resource/${data.id}`]);
  }

  serializeToHTML(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText = node.text.length > 250 ? `${node.text.slice(0, 250)}...` : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h2':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h3':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h4':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h5':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h6':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<p>${this.serializeToHTML(
              node.children
            )}</p>`;

          default:
            return `<p>${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 250 ? `${result.slice(0, 250)}...` : result;
  }


  private escapeHTML(text: string): string {
    return text;
  }




}
